 
<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <!-- <div class="personal-details">
                <h4 class="personal-details-title">Notification List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Message</th>
                      <th scope="col">To User</th>
                      <th scope="col">From User</th>
                      <th scope="col">Notification Type</th>
                      <th scope="col">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of notification | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                    }; let i=index">
                      <th scope="col" >{{x.message}}</th>
                      <th scope="col" >{{x.toUser}}</th>
                      <th scope="col" >{{x.fromUser}}</th>
                      <th scope="col" >{{x.notifyType}}</th>
                      <th scope="col" >{{x.date | date:'medium'}}</th>
                    </tr>
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="notification.length != 0">
                <pagination-controls
                  previousLabel="Prev"
                  nextLabel="Next"
                  (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
              </div>
            </div> -->

            <div class="personal-details">
          
              <div class="header-block">
                  <div class="header-title">
                      <p>Notification List</p>
                  </div>
                  <div class="add-block">
                      <div class="search">
                          <form autocomplete="off" >
                              <input type="text" placeholder="search">
                          </form>
                          <i class="bi bi-search" ></i>
                      </div>
                  </div>
              </div>

              <table class="table table-striped">
                  <thead>
                      <tr>
                      <th style="width: 30%;">Message</th>
                      <th style="width: 15%;">To User</th>
                      <th style="width: 15%;">From User</th>
                      <th style="width: 20%;">Notification Type</th>
                      <th style="width: 20%;">Date</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let x of notification | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                      }  ;let i = index">
                      <p style="width: 30%;" pTooltip="{{x.message}}" tooltipPosition="top">{{x.message}}</p>
                      <p style="width: 15%;">{{x.toUser}}</p>
                      <p style="width: 15%;">{{x.fromUser}}</p>
                      <p style="width: 20%;">{{x.notifyType}}</p>
                      <p style="width: 20%;">{{x.date | date:'medium'}}</p>
                  </div>
              </div>


              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>

              <div class="loader"  *ngIf="!isLoading && notification.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>

              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                  </p-paginator>
              </div>


          </div>
        </div>
    </div>
  </div>

 
